export function getRecaptchaToken(vm, action, timeoutMs) {
  const timeout = Number(timeoutMs) || 15000;

  if (
    !vm ||
    typeof vm.$recaptchaLoaded !== "function" ||
    typeof vm.$recaptcha !== "function"
  ) {
    return Promise.reject(new Error("recaptcha-unavailable"));
  }

  return withTimeout(vm.$recaptchaLoaded(), timeout, "recaptcha-load-timeout")
    .then(function() {
      return withTimeout(
        vm.$recaptcha(action),
        timeout,
        "recaptcha-token-timeout"
      );
    })
    .then(function(token) {
      if (typeof token !== "string" || !token) {
        throw new Error("recaptcha-empty-token");
      }
      return token;
    });
}

function withTimeout(promise, timeoutMs, message) {
  return new Promise(function(resolve, reject) {
    var settled = false;
    var timer = setTimeout(function() {
      if (settled) {
        return;
      }
      settled = true;
      reject(new Error(message));
    }, timeoutMs);

    Promise.resolve(promise).then(
      function(value) {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(timer);
        resolve(value);
      },
      function(error) {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/recaptcha.js